import { render, staticRenderFns } from "./optimize-action-menu.vue?vue&type=template&id=0ad0b64a"
import script from "./optimize-action-menu.vue?vue&type=script&lang=js"
export * from "./optimize-action-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports